import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subject, filter } from 'rxjs';
import { AuthenticationService } from './authentication.service';
import { environment } from 'src/environments/environment';
import { SignalEvent, SignalEventType } from '../models/SignalModel';

@Injectable({
  providedIn: 'root'
})
export class SignalRService {
  private hubConnection!: signalR.HubConnection;
  private signalEvent!: Subject<any>;

  constructor(
    private authService: AuthenticationService,
    private snackBar: MatSnackBar,
    private readonly translate: TranslateService
  ) {
    this.signalEvent = new Subject<any>();
  }

  public startConnection = () => {
    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(environment.signalR, {
        accessTokenFactory: () => this.authService.currentUserValue?.Token ?? '',
        transport: signalR.HttpTransportType.WebSockets
      }).build();

    this.hubConnection.start()
      .then((data) => {
        this.setupSignalREvents();
        this.authService.SignalRConnectionId.next(this.hubConnection.connectionId);
        console.log('Connection started ...')
      })
      .catch((err: any) => console.log('Error while starting connection ... ' + err));

  }
  stopConnection() {
    if (this.hubConnection) {
      this.hubConnection.stop()
        .then(() => console.log('Connection stopped ...'))
        .catch((err: any) => console.log('Error while stopping connection ... ' + err));
    }
  }
  // /*
  //  * ***************************************************************
  //  * ***************************************************************
  //  * ***************************************************************
  //  * ***************************************************************
  // */

  getDataStream<TDataShape>(...filterValues: SignalEventType[]): Observable<SignalEvent<TDataShape>> {
    return this.signalEvent.asObservable().pipe(filter(event => filterValues.some(f => f === event.type)));
  }

  private onMessage<TDataShape>(payload: SignalEvent<TDataShape>) {
    this.signalEvent.next(payload);
  }

  private setupSignalREvents() {
    this.hubConnection?.on('changeNotificationCount', (msg: string) => {
      this.onMessage({ type: SignalEventType.changeNotificationCount, data: { msg } });
    });
    this.hubConnection?.on('newLabUpdate', (labId: number) => {
      this.onMessage({ type: SignalEventType.newLabUpdate, data: { labId } });
    });
    this.hubConnection?.on('NewTicket', (ticketId: number) => {
      this.onMessage({ type: SignalEventType.NewTicket, data: { ticketId } });
    });
  }

  // /*******************************************************/
  notify(msg?: string) {
    this.snackBar.open(this.translate.instant('signal.You have a new notification'), '✖', {
      duration: 3000,
      horizontalPosition: 'end',
      verticalPosition: 'top'
    });
  }
}
